import { AddIcon } from "@chakra-ui/icons";
import { Box, Button, Text, Image } from "@chakra-ui/react";
import bannerSidebar from "assets/img/layout/banner-sidebar.svg";

interface SidebarBannerProps {
  onStartOrder: () => void;
}

export const SidebarBanner: React.FC<SidebarBannerProps> = ({ onStartOrder }) => {
  return (
    <Box
      bg="#E0E9FF"
      borderRadius="12px"
      border="1px solid #3A7BFF"
      p="16px"
      pt="20px"
      pb="0"
      position="relative"
      overflow="hidden"
      height="250px"
      w="200px"
      display="flex"
      flexDirection="column"
      shadow="0px 2px 4px 0px #00000033"
    >
      {/* Content Wrapper */}
      <Box position="relative" zIndex="1" flex="0 0 auto">
        {/* Text */}
        <Text
          fontFamily="General Sans, sans-serif"
          fontSize="20px"
          fontWeight="600"
          lineHeight="130%"
          color="#1F2937"
          mb="16px"
          padding="0 8px"
          textAlign="center"
        >
          Let's get your next translation going
        </Text>

        {/* Button */}
        <Button
          onClick={onStartOrder}
          bg="#4C6FFF"
          color="#FFFFFF"
          borderRadius="999px"
          leftIcon={<AddIcon w="14px" h="14px" boxSize="14px" />}
          bgColor="#3A7BFF"
          fontSize="16px"
          fontWeight="600"
          px="16px"
          py="12px"
          h="48px"
          w="166px"
          border="1px solid #3A7BFF"
          _hover={{
            bgColor: "#FFFFFF",
            color: "#3A7BFF",
          }}
        >
          Start Order
        </Button>
      </Box>

      {/* Bottom Banner Image */}
      <Box
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        zIndex="0"
      >
        <Image src={bannerSidebar} alt="" width="100%" height="auto" display="block" />
      </Box>
    </Box>
  );
};

export default SidebarBanner;
